import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading, setReportSection50BisList, setReportSection50BisList2 } from "../../slices/reportSlice";
import { generateRandomString } from "utils/helper";
import * as services from "../../services/reportApi";
import useOptions from "../../../masterData/hooks/useOptions";
import dayjs from "dayjs"
import { Modal } from "antd";

function useSection50BisReport() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [search, setSearch] = useState({});
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const currentEmployee = useSelector((state) => state.company.currentEmployee);
    const reportSection50BisTable = useSelector((state) => state.report.reportSection50BisTable || []);
    const reportSection50BisTable2 = useSelector((state) => state.report.reportSection50BisTable2 || []);
    const [showReport, setShowReport] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSendMailModalOpen, setIsSendMailModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState({});
    const [pagination, setPagination] = useState({ page: 0, currentPage: 0, size: 10 });
    const [pagination2, setPagination2] = useState({ page: 0, currentPage: 0, size: 10 });
    const [year, setYear] = useState(dayjs().year());
    const [mode, setMode] = useState("M01");
    const { employmentTypeOptions, employeeStatusTypeOptions, getEmploymentTypeOptions, getEmployeeStstuaTypeOptions } = useOptions();

    function toParams(params = {}) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            pagination: {
                page: pagination?.page,
                size: pagination?.pageSize,
            },
            sortBy: sortBy
                .filter((s) => s.order !== undefined)
                .map((s) => ({
                    direction: s.order === "descend" ? "desc" : "asc",
                    property: s.field,
                })),
        };
        return modifiedParams;
    }

    const getSection50BisTable = useCallback(
        async (params = {}, changeYear) => {
            // console.log("🚀 ~ params:", params)
            try {
                console.log("params.pagination", params, params?.month?.format("MM"), year, changeYear);
                if (params.pagination == null) {
                    params.pagination = pagination
                }
                if (params.month) {
                    params.month = params?.month?.format("MM");
                }
                dispatch(setIsLoading(true));
                const response = await services.getSection50BisReport({
                    ...params,
                    ...params.pagination,
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    informationType: 1,
                    year: changeYear || year
                });

                dispatch(setReportSection50BisList(response?.data?.page?.content));

                setPagination({
                    ...pagination,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize ?? 10,
                    total: response?.data?.page?.totalElements,
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, pagination, year]
    );
    const getSection50ExtraBisTable = useCallback(
        async (params = {}, changeYear) => {
            // console.log("🚀 ~ params:", params)
            try {
                console.log("params.pagination", params.pagination);
                if (params.pagination == null) {
                    params.pagination = pagination
                }

                if (params.month) {
                    params.month = params?.month?.format("MM");
                }
                dispatch(setIsLoading(true));
                const response = await services.getSearchSection50ExtraBisReportPaging({
                    ...params,
                    ...params.pagination,
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    informationType: 1,
                    year: changeYear || year
                });

                dispatch(setReportSection50BisList2(response?.data?.page?.content));

                setPagination2({
                    ...pagination2,
                    current: response?.data?.page?.pageable?.pageNumber + 1,
                    pageNo: response?.data?.page?.pageable?.pageNumber + 1,
                    size: response?.data?.page?.pageable?.pageSize ?? 10,
                    total: response?.data?.page?.totalElements,
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, pagination2, year]
    );

    const exportSection50BisReportReportPdf = useCallback(
        async (params = {}, changeYear) => {
            try {

                dispatch(setIsLoading(true));
                services.ExportSection50BisReportPdf({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    ...params,
                    ...params.pagination,
                    idEmployee: params.employeeId,
                    ...search,
                    ...pagination,
                    isReport: "Y",
                    sortBy: params.sortBy,
                    year: changeYear || year,
                }).then(res => {
                    const url = window.URL.createObjectURL(res?.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${params.employeeNo ?? dayjs().format("YYYYMMDD")}_(50ทวิ).pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );
    const sendSection50BisReportReportPdf = useCallback(
        async (params = {}, changeYear) => {
            try {
                dispatch(setIsLoading(true));

                services.sendEmailThawi50({ ...params, idEmployee: params.employeeId, isReport: "Y" });
                // getSection50BisTable({ search, ...params.year, ...pagination })
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );
    const sendSection50BisReportReportPdfAll = useCallback(
        async (params = {}, changeYear) => {
            try {
                dispatch(setIsLoading(true));

                services.sendEmailThawi50All({ ...search, isReport: "Y" });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );
    const exportSection50BisReportReportPdfExtra = useCallback(
        async (params = {}, changeYear) => {
            try {

                dispatch(setIsLoading(true));
                services.ExportSection50BisReportPdfExtra({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    ...params,
                    ...params.pagination,
                    idEmployee: params.employeeId,
                    ...search,
                    ...pagination,
                    isReport: "Y",
                    sortBy: params.sortBy,
                    year: changeYear || year,
                }).then(res => {
                    const url = window.URL.createObjectURL(res?.data);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${params.employeeNo ?? dayjs().format("YYYYMMDD")}_(50ทวิ).pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );
    const sendSection50BisReportReportPdfExtra = useCallback(
        async (params = {}, changeYear) => {
            try {
                dispatch(setIsLoading(true));

                services.sendEmailThawi50Extra({ ...params, idEmployee: params.employeeId, isReport: "Y" });
                // getSection50BisTable({ search, ...params.year, ...pagination })
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );
    const sendSection50BisReportReportPdfAllExtra = useCallback(
        async (params = {}, changeYear) => {
            try {
                dispatch(setIsLoading(true));

                services.sendEmailThawi50AllExtra({ ...search, isReport: "Y" });
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch, search]
    );
    const confirmModalFn = useCallback((params, fn = () => { }, confirmMsg = "") => {
        console.log("confirm modal", params);
        if (params == 1) {
            Modal.confirm({
                title: t("dialog.confirmation.header") + t('action.download'),
                content: confirmMsg,
                onOk() {
                    if (mode == "M01") {

                        exportSection50BisReportReportPdf({ report: "all" });
                    } else if (mode == "M02") {

                        exportSection50BisReportReportPdfExtra({ report: "all" });
                    }
                },
                okText: t("common.confirm"),
                cancelText: t("common.cancel"),
            });
        } else {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: confirmMsg,
                onOk() {
                    if (mode == "M01") {

                        sendSection50BisReportReportPdfAll();
                    } else if (mode == "M02") {

                        sendSection50BisReportReportPdfAllExtra();
                    }
                },
                okText: t("common.confirm"),
                cancelText: t("common.cancel"),
            });
        }

    }, [sendSection50BisReportReportPdfAll, sendSection50BisReportReportPdfAllExtra, mode])

    const onChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            const modifiedParams = toParams({
                pagination: {
                    page: tablePagination.current - 1,
                    pageSize: tablePagination.pageSize,
                    current: tablePagination.current - 1,
                },
                sortBy: modifiedSorter,
            });

            setPagination({ ...pagination, ...modifiedParams?.pagination })
            if (mode == "M01")
                getSection50BisTable({ ...modifiedParams, request: pagination.request, changeYear: dayjs(year).format("YYYY"), ...search });
            if (mode == "M02")
                getSection50ExtraBisTable({ ...modifiedParams, request: pagination.request, changeYear: dayjs(year).format("YYYY"), ...search });
        },
        [getSection50BisTable, getSection50ExtraBisTable, pagination, search, mode]
    );

    useEffect(() => {
        if (currentCompany) {
            getEmploymentTypeOptions({ companyId: currentCompany });
            getEmployeeStstuaTypeOptions();
        }
    }, [currentCompany, getEmployeeStstuaTypeOptions, getEmploymentTypeOptions])

    const showModal = () => {
        setIsModalOpen(true);
    };

    // const handleSearch = (values) => {
    //     setShowReport(true)
    //     setSearch({})
    //     setSearch({ ...values, year: values?.year?.format("YYYY") })

    //     if (mode == "M01")
    //         getSection50BisTable({ ...values, ...pagination, year: values?.year?.format("YYYY") })
    //     if (mode == "M02")
    //         getSection50ExtraBisTable({ ...values, ...pagination, year: values?.year?.format("YYYY") });
    // };

    const handleSearch = useCallback(
        (values) => {
            setShowReport(true)
            setSearch({})
            setSearch({ ...values, year: values?.year?.format("YYYY") })
            console.log("modemode", mode);

            if (mode == "M01")
                getSection50BisTable({ ...values, ...pagination, year: values?.year?.format("YYYY") })
            if (mode == "M02")
                getSection50ExtraBisTable({ ...values, ...pagination2, year: values?.year?.format("YYYY") });
        },
        [mode, getSection50BisTable, pagination,
            getSection50ExtraBisTable, pagination2],
    )


    const handleSendEmail = (record) => {
        setSelectedRecord(record)
        setIsSendMailModalOpen(true)
    }

    return {
        showReport,
        isModalOpen,
        pagination,
        pagination2,
        reportSection50BisTable,
        reportSection50BisTable2,
        employmentTypeOptions,
        employeeStatusTypeOptions,
        handleSearch,
        search,
        showModal,
        setIsModalOpen,
        onChange,
        setYear,
        confirmModalFn,
        exportSection50BisReportReportPdf,
        sendSection50BisReportReportPdf,
        exportSection50BisReportReportPdfExtra,
        sendSection50BisReportReportPdfExtra,
        isSendMailModalOpen,
        setIsSendMailModalOpen,
        handleSendEmail,
        selectedRecord,
        mode,
        setMode
    }
}

export default useSection50BisReport;